var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderLine(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 906.76 9.3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fbac46;\n      }\n\n      .cls-1, .cls-2, .cls-3, .cls-4, .cls-5, .cls-6, .cls-7 {\n        stroke-width: 0px;\n      }\n\n      .cls-2 {\n        fill: #799dab;\n      }\n\n      .cls-3 {\n        fill: #3c5572;\n      }\n\n      .cls-4 {\n        fill: #e5b989;\n      }\n\n      .cls-5 {\n        fill: #f79330;\n      }\n\n      .cls-6 {\n        fill: #f3eb43;\n      }\n\n      .cls-7 {\n        fill: #edd1b0;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Capa_1",
    "data-name": "Capa 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 0,
    y: 0,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 129.2,
    y: 0,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    x: 258.79,
    y: 0,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 388.38,
    y: 0,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 517.98,
    y: 0,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-7",
    x: 647.57,
    y: 0,
    width: 129.59,
    height: 9.3
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-4",
    x: 777.16,
    y: 0,
    width: 129.59,
    height: 9.3
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderLine);
export default __webpack_public_path__ + "static/media/Header-Line.f76efbcdfc21a99a29ce501f87d6be05.svg";
export { ForwardRef as ReactComponent };